import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: "displayValue",
    standalone: false
})
export class DisplayValuePipe implements PipeTransform {
	constructor(private readonly translateService: TranslateService) {}

	transform(value: unknown): string {
		if (value === null || value === undefined) {
			return "-";
		}

		if (typeof value === "boolean") {
			return value
				? this.translateService.instant("common.yes")
				: this.translateService.instant("common.no");
		}

		if (typeof value === "number") {
			return value.toString();
		}

		if (typeof value === "string") {
			return value.trim() || "-";
		}

		return String(value);
	}
}
